import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field } from "@/components/shared/Common";
import { api, errMsg } from "@/lib/api";

const EMPTY = { code: "", name: "", worked: true, paid_shift: false, color: "#5CD500", active: true, isNew: true };

export const AttendanceCodesDialog = ({ open, onOpenChange, codes, onSaved }) => {
  const [edit, setEdit] = useState(null);
  const save = async () => {
    const { isNew, ...body } = edit;
    try { isNew ? await api.post("/rrhh/attendance-codes", body) : await api.patch(`/rrhh/attendance-codes/${edit.code}`, body); toast.success("Código guardado"); setEdit(null); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[92vh] overflow-y-auto" data-testid="attendance-codes-dialog">
        <DialogHeader><DialogTitle>Códigos de asistencia</DialogTitle></DialogHeader>
        <div className="space-y-1">{codes.map((c) => (
          <button key={c.code} data-testid={`att-code-edit-${c.code}`} onClick={() => setEdit({ ...c })} className={`w-full flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-left hover:bg-[#f6fbf2] ${c.active ? "" : "opacity-50"}`}>
            <span className="w-14 rounded font-mono text-xs font-bold text-white text-center py-0.5" style={{ background: c.color }}>{c.code}</span>
            <span className="flex-1">{c.name}</span>
            <span className="text-xs text-[#5b6656]">{c.worked ? "Trabajado" : "No trabajado"}{c.paid_shift ? " · pago por turno" : ""}</span>
          </button>))}</div>
        <Button data-testid="att-code-new-btn" variant="outline" className="rounded-full w-fit" onClick={() => setEdit({ ...EMPTY })}>Nuevo código</Button>
        {edit && <div className="syc-card p-4 space-y-3" data-testid="att-code-form">
          <div className="grid grid-cols-[110px_1fr_70px] gap-3">
            <Field label="Código"><Input data-testid="att-code-code-input" disabled={!edit.isNew} value={edit.code} onChange={(e) => setEdit({ ...edit, code: e.target.value.toUpperCase() })} /></Field>
            <Field label="Nombre"><Input data-testid="att-code-name-input" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} /></Field>
            <Field label="Color"><input data-testid="att-code-color-input" type="color" className="h-10 w-full rounded border" value={edit.color} onChange={(e) => setEdit({ ...edit, color: e.target.value })} /></Field>
          </div>
          <div className="flex flex-wrap gap-5 text-sm">
            {[["worked", "Cuenta como día trabajado"], ["paid_shift", "Se paga por turno"], ["active", "Activo"]].map(([k, l]) => (
              <label key={k} className="flex items-center gap-2"><Switch data-testid={`att-code-${k}-switch`} checked={edit[k]} onCheckedChange={(v) => setEdit({ ...edit, [k]: v })} />{l}</label>))}
          </div>
          <Button data-testid="att-code-save-btn" className="rounded-full" onClick={save}>Guardar código</Button>
        </div>}
      </DialogContent>
    </Dialog>
  );
};
